/**
Copyright (c) 2022–2026 Podstack.ai
All rights reserved.
Proprietary and Confidential.
Unauthorized copying of this file, via any medium, is strictly prohibited.
This file is part of the Podstack Platform.
*/

import { BillingPeriod } from '../../../types';

export type LaunchStep = 'gpu' | 'template' | 'configure' | 'review';

export const LAUNCH_STEPS: LaunchStep[] = ['gpu', 'template', 'configure', 'review'];

export interface PodForm {
  name: string;
  project_id: string;
  image: string;
  cpu_cores: number;
  memory_gb: number;
  storage_gb: number;
  gpu_count: number; // Number of physical GPUs (integer, maps to nvidia.com/gpu)
  gpu_cores: number; // Percentage per GPU (0-100, maps to nvidia.com/gpumem-percentage)
  gpu_type: string;
  replicas: number;
  billing_period: BillingPeriod;
  env_vars: Record<string, string>;
  ports: number[];
  is_private_registry: boolean;
  registry_url: string;
  registry_username: string;
  registry_password: string;
  entry_point_command: string;
  ssh_key_id: string;
}
